<template>
    <div>
  <header id="main-header" class="main-header" :class="{ scrolled: isScrolled }">
    <div class="container">
      <span class="main-logo">
        <router-link class="desktop" to="/" @click="hidePopups">
          <v-Icon class="logo" alt="FPS - logo" name="logo" />
        </router-link>
      </span>

      <div class="main-nav-wrapper" :class="{ 'active-nav': showMobileMenu }">
        <nav id="main-nav" class="main-nav" v-if="!showIfLandingsPage && $route.name !== 'Home'">
          <ul>
            <li>
              <router-link class="home" to="/#waarom-kiezen-voor-fps" @click="scrollToAnchor"
                >Waarom FPS</router-link
              >
            </li>
            <li>
              <router-link class="home" to="/#klanten" @click="scrollToAnchor"
                >Klanten
              </router-link>
            </li>
            <li>
              <router-link class="home" to="/#faq" @click="scrollToAnchor">Faq</router-link>
            </li>
          </ul>
        </nav>

        <nav id="main-nav" class="main-nav" v-if="$route.name == 'Home'">
          <ul>
            <li>
              <a class="home" href="/#waarom-kiezen-voor-fps" @click="scrollToAnchor">Waarom FPS</a>
            </li>
            <li>
              <a class="home" href="/#klanten" @click="scrollToAnchor">Klanten </a>
            </li>
            <li>
              <a class="home" href="/#faq" @click="scrollToAnchor">Faq</a>
            </li>
          </ul>
        </nav>

        <nav id="main-nav" class="main-nav mobile-nav" v-else>
          <ul>
            <li>
              <router-link class="home" to="/" @click="scrollToAnchor">Naar home</router-link>
            </li>
            <li>
              <router-link to="/contact" @click="hidePopups">Neem contact op</router-link>
            </li>
          </ul>
        </nav>
      </div>

      <nav id="side-nav" class="side-nav">
        <ul>
          <li class="login-btn" v-if="!isAuthenticated">
            <!-- <button class="regular-btn" @click="loginPopup">Login</button> -->
            <router-link class="home" to="/inloggen" @click="hidePopups">Login</router-link>
          </li>
          <li class="login-btn" v-if="isAuthenticated">
            <router-link class="home" to="/" @click="hidePopups">Dashboard</router-link>
          </li>
          <li class="contact-btn">
            <router-link class="button contact-btn" to="/contact" @click="hidePopups"
              >Neem contact op</router-link
            >
          </li>
          <li class="mobile-menu-btn">
            <button
              type="button"
              class="button mobile-menu-btn"
              to="/contact"
              @click="
                hidePopups;
                toggleMobileMenu();
              "
              :class="{ 'active-btn': showMobileMenu }"
            ></button>
          </li>
        </ul>
      </nav>
    </div>
  </header>

  <transition name="fade">
    <ForgotPasswordPopup v-if="globalStore.displayPasswordPopup" />
  </transition>
</div>
</template>

<script>
//Vue
import { defineComponent, ref, computed, watch, onMounted, onUnmounted } from 'vue'
// import { useRoute } from 'vue-router'

import { clearData } from '@streampac.io/chef_sp_1'

import { useGlobalStore } from '@/stores/global'
import { useLiveChatStore } from '@/stores/liveChat'

import { useRoute, useRouter } from 'vue-router'

//Composables
import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useCurrentUserData } from '@/composables/useUserData'

//Components
// import SearchBar from '@/components/SearchBar/index.vue'
import ForgotPasswordPopup from '@/components/ForgotPasswordPopup/index.vue'

export default defineComponent({
  components: {
    ForgotPasswordPopup
  },
  setup() {
    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const globalStore = useGlobalStore()
    const liveChatStore = useLiveChatStore()

    const $route = useRoute()
    const $router = useRouter()

    const notificationAmount = ref(null)

    const showSideMenu = ref(false)

    const userData = ref(null)
    const showMobileMenu = ref(false)
    // const removeExtraMenu = ref(false);
    // const removeLoginBar = ref(false);

    const { getCurrentUser, getCurrentUserProfile } = useCurrentUserData()
    // const userLevel = computed(() => {

    //     if (getCurrentUser.value?.level == 2) {
    //         return 'user-hbo';
    //     } else if (getCurrentUser.value?.level == 1) {
    //         return 'user-mbo';
    //     } else {
    //         return null;
    //     }
    // });

    const newMessagesInChatAmount = ref(0)

    const isScrolled = ref(false)

    // Scroll handler function
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      isScrolled.value = scrollTop > 30
    }

    // Add scroll event listener on mount
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)

      handleScroll()
    })

    // Remove scroll event listener on unmount
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    watch(
      () => $route.path,
      () => {
        globalStore.hideLoginPopup()
        globalStore.hidePasswordPopup()

        showSideMenu.value = false
        showMobileMenu.value = false

        globalStore.mobileMenuDisplayTrue()
      }
    )

    watch(
      () => isAuthenticated.value,
      () => {
        globalStore.hideLoginPopup()
        globalStore.hidePasswordPopup()

        showSideMenu.value = false
      }
    )

    watch(
      () => getCurrentUserProfile.value,
      () => {
        globalStore.setUserData(getCurrentUserProfile.value)

        userData.value = getCurrentUserProfile.value
      }
    )

    function handleLogout() {
      clearData()
      useAuthenticationData().setAuthenticated(false)

      globalStore.storeRemoveAuthenticatedStatus()
      globalStore.deleteUserSavedData()

      $router.replace({ name: 'Home' })
      showSideMenu.value = false
    }

    function loginPopup() {
      globalStore.toggleLoginPopup()

      showMobileMenu.value = false
    }

    function forgotPasswordPopup() {
      globalStore.hideLoginPopup()
      globalStore.showPasswordPopup()

      showMobileMenu.value = false
    }

    function hidePopups() {
      globalStore.hideLoginPopup()
      globalStore.hidePasswordPopup()
    }

    function toggleMobileMenu() {
      showMobileMenu.value = !showMobileMenu.value
    }

    function toggleSideMenu() {
      showSideMenu.value = !showSideMenu.value
    }

    watch(
      () => liveChatStore.newMessagesInChat,
      () => {
        newMessagesInChatAmount.value = liveChatStore.newMessagesInChat
      },
      { deep: true }
    )

    function activateChat() {
      liveChatStore.toggleDisplayChat()

      //Remove mobile menu to make room for chat.
      globalStore.toggleMobileMenuDisplay()
    }

    const showIfLandingsPage = computed(() => {
      return $route.meta.accountSetupPage
    })

    function scrollToAnchor(event) {
      hidePopups()
      showMobileMenu.value = false

      event.preventDefault()
      let targetId

      if (event.target.getAttribute('href').startsWith('/#')) {
        targetId = event.target.getAttribute('href').substring(2)
      } else {
        targetId = event.target.getAttribute('href').substring(1)
      }

      setTimeout(() => {
        const element = document.getElementById(targetId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 300)
    }

    return {
      globalStore,
      userData,
      showMobileMenu,
      getCurrentUserProfile,
      // removeExtraMenu,
      // removeLoginBar,
      isAuthenticated,
      getCurrentUser,
      notificationAmount,
      showSideMenu,
      newMessagesInChatAmount,
      isScrolled,
      //functions
      handleLogout,
      loginPopup,
      forgotPasswordPopup,
      hidePopups,
      toggleMobileMenu,
      toggleSideMenu,
      activateChat,
      showIfLandingsPage,
      scrollToAnchor
    }
  }
})
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
